import { State } from 'src/types'
import { webOfShallowPocket, webTop } from '../web'
import { webTop0, webTop1, webTop2, webTop3 } from '../lace/web'
import {
  laceOfConnectWebToCatchFace,
  laceOfLeftConnectWebToCatchFace,
  laceOfRightConnectWebToCatchFace
} from 'src/features/atoms/glove/drawer/rightThrow/catchermitt/back/lace/connectWeb'
import { laceOfWebTopToIndexFinger, laceOfWebTopToThumbFinger } from '../lace/connectWeb'
import { arroundEdge3, arroundEdge4, arroundEdge5, arroundEdge6, arroundEdge8 } from '../lace/arroundEdge'

export const shallowWeb = async (ctx: CanvasRenderingContext2D, state: State, printLeatherTypeValue?: string): Promise<void> => {
  // 革紐パーツ
  laceOfWebTopToIndexFinger(ctx, state.lace.color) //
  laceOfWebTopToThumbFinger(ctx, state.lace.color) //

  // 本体パーツ
  await webTop(ctx, state.web.color, state.stitch.color, printLeatherTypeValue) // 残す
  await webOfShallowPocket(ctx, state.web.color, state.stitch.color, printLeatherTypeValue) // 変更

  webTop3(ctx, state.lace.color)
  webTop2(ctx, state.lace.color, 12, 18)
  webTop2(ctx, state.lace.color, 0, 0)
  webTop2(ctx, state.lace.color, -14, -17)
  webTop1(ctx, state.lace.color, 110, -73, 13)
  webTop1(ctx, state.lace.color, 89, -28, 8)
  webTop1(ctx, state.lace.color, 69, -42, 8)
  webTop1(ctx, state.lace.color, 40, 30)
  webTop1(ctx, state.lace.color, 20, 14)
  webTop1(ctx, state.lace.color, 0, 0)
  webTop1(ctx, state.lace.color, -20, -13)
  webTop0(ctx, state.lace.color)

  // 順番が大事なのでこの中でarroundEdgeも一部描画
  arroundEdge4(ctx, state.lace.color)
  arroundEdge5(ctx, state.lace.color)
  arroundEdge6(ctx, state.lace.color, 5, 0)
  arroundEdge6(ctx, state.lace.color, -5, 0)
  // webToThumbFinger(ctx, state.lace.color)
  laceOfConnectWebToCatchFace(ctx, state.lace.color, 0, 0)
  laceOfConnectWebToCatchFace(ctx, state.lace.color, 70, 55)

  // 順番が大事なのでこの中でarroundEdgeも一部描画
  arroundEdge8(ctx, state.lace.color)
  laceOfLeftConnectWebToCatchFace(ctx, state.lace.color)
  arroundEdge3(ctx, state.lace.color, -55, 111, -12)
  laceOfRightConnectWebToCatchFace(ctx, state.lace.color)
}
